import React, { memo } from 'react';
import { useSelector } from 'react-redux';
import { PureWirelessLayerControl } from './PureWirelessLayerControl';

interface RootState {
  sinatra: {
    irp: {
      irpVersion?: string;
    };
  };
}

/**
 * Controls for additional layers (internal partners, Pure Wireless, etc.)
 * These are layers that don't fit into GIS or Spatial Layer categories.
 */
export const AdditionalLayersControls = memo(() => {
  const irpVersion = useSelector(
    (state: RootState) => state.sinatra?.irp?.irpVersion,
  );

  return (
    <div>
      <PureWirelessLayerControl irpVersion={irpVersion} />
    </div>
  );
});

export default AdditionalLayersControls;
